import { useEffect } from 'react';
import { prop } from 'ramda';
import { useLiveGamesSelector } from 'js/store/hooks';

import { useLiveGamesOnSocketOpen } from './useLiveGamesOnSocketOpen';
import { useLiveGamesOnSocketClose } from './useLiveGamesOnSocketClose';
import { useLiveGamesOnSocketMessage } from './useLiveGamesOnSocketMessage';
import { useLiveGamesOnSocketReconnected } from './useLiveGamesOnSocketReconnected';

export const useLiveGamesListeners = () => {
    const liveGamesOnSocketOpen = useLiveGamesOnSocketOpen();
    const liveGamesOnSocketClose = useLiveGamesOnSocketClose();
    const liveGamesOnSocketMessage = useLiveGamesOnSocketMessage();
    const liveGamesOnSocketReconnected = useLiveGamesOnSocketReconnected();
    const socket = useLiveGamesSelector(prop('socket'));

    useEffect(() => {
        socket?.on('open', liveGamesOnSocketOpen);
        socket?.on('close', liveGamesOnSocketClose);
        socket?.on('message', liveGamesOnSocketMessage);
        socket?.on('reconnected', liveGamesOnSocketReconnected);

        return () => {
            socket?.off('open', liveGamesOnSocketOpen);
            socket?.off('close', liveGamesOnSocketClose);
            socket?.off('message', liveGamesOnSocketMessage);
            socket?.off('reconnected', liveGamesOnSocketReconnected);
        };
    }, [socket, liveGamesOnSocketOpen, liveGamesOnSocketClose, liveGamesOnSocketMessage, liveGamesOnSocketReconnected]);
};
